export default __webpack_public_path__ + "static/media/workspaceuser.b04ef24c.svg";